var React = require('react');

function IconYouTube (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group 4"},[React.createElement("circle",{"id":"Ellipse 5","cx":"21","cy":"21","r":"21","fill":"#003DA6","key":0}),React.createElement("g",{"id":"YouTube","key":1},[React.createElement("path",{"id":"Vector","d":"M28.7829 28.4118H13.9582C11.9746 28.4118 10.3765 26.6575 10.3765 24.4998V17.5003C10.3765 15.3337 11.9826 13.5883 13.9582 13.5883H28.7829C30.7665 13.5883 32.3647 15.3425 32.3647 17.5003V24.4998C32.3727 26.6663 30.7665 28.4118 28.7829 28.4118Z","fill":"white","key":0}),React.createElement("path",{"id":"Vector_2","d":"M25.2603 20.8904L19.0239 17.2942V24.4867L25.2603 20.8904Z","fill":"#003DA6","key":1})])]));
}

IconYouTube.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = IconYouTube;

IconYouTube.default = IconYouTube;
